// extracted by mini-css-extract-plugin
export default {"hideTooltip":"B8-z","fadeIn":"C8-z","delay":"D8-z","recommendedSizeTooltip":"E8-z"};